import React from 'react';
import { ISubMenuItem } from './interfaces';
import {
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
} from '@mui/material';

export const SubMenuItem: React.FC<ISubMenuItem> = ({
  key,
  label,
  onClick,
  active = false,
}): JSX.Element => {
  const theme = useTheme();

  return (
    <ListItem key={key} sx={{ pl: '20px' }} disablePadding>
      <ListItemButton
        selected={active}
        onClick={onClick}
        sx={{
          paddingY: '5px',
          paddingX: '12px',
          mx: '5px',
          borderLeft: `3px solid ${
            active ? theme.palette.primary.main : theme.palette.grey[300]
          }`,
        }}
      >
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: 14,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
